import { WebPlugin } from '@capacitor/core';
import { AdResult, NativeAdOptions, NativeAdTriggerOptions } from '.';

import type { AdmobAdsPlugin, BannerAdOptions, InterstitialAdOptions, RewaredInterstitialAdOptions, RewaredVideoAdOptions } from './definitions';

export class AdmobAdsWeb extends WebPlugin implements AdmobAdsPlugin {

  async showBannerAd(options: BannerAdOptions): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async hideBannerAd(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  async resumeBannerAd(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  async removeBannerAd(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async loadNativeAd(options: NativeAdOptions): Promise<{ ads: AdResult[]; }> {
    throw new Error('Method not implemented.');
  }

  async triggerNativeAd(options: NativeAdTriggerOptions): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async loadRewardedVideoAd(options: RewaredVideoAdOptions): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async showRewardedVideoAd(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async loadRewardedInterstitialAd(options: RewaredInterstitialAdOptions): Promise<void> {
    throw new Error('Method not implemented.');
  }
  async showRewardedInterstitialAd(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async loadInterstitialAd(options: InterstitialAdOptions): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async showInterstitialAd(): Promise<void> {
  }
}
